var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"space-top4 div-center"},[_c('a-icon',{staticStyle:{"fontSize":"48px"},attrs:{"type":"loading"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }